import { Portal } from '@mui/material';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useMap } from 'react-map-gl';

import MapLegendToggle from '../map-legend-toggle/map-legend-toggle';
import MapOverlayPanel from '../map-overlay-panel/map-overlay-panel';

import styles from './legend-control.module.css';

export type LegendPlacement = 'bottom-left' | 'below-toggle';

export interface LegendControlProps {
  children?: React.ReactNode;
  /** Mobile: stack legend under the toggle (avoids bottom sheet / carousel overlap). */
  legendPlacement?: LegendPlacement;
}

export function LegendControl(props: LegendControlProps) {
  const legendPlacement = props.legendPlacement ?? 'bottom-left';
  const { t } = useTranslation(['map'], { useSuspense: false });
  const [checked, setChecked] = useState(true);
  const map = useMap();
  const mapId = map.current?.getMap().getContainer().id;

  if (!mapId) {
    return null;
  }

  const topLeftContainer =
    document &&
    document
      .getElementById(mapId)
      ?.getElementsByClassName('mapboxgl-ctrl-top-left')[0];

  const toggle = (
    <MapLegendToggle
      checked={checked}
      label={t('map:legend')}
      onCheckedChange={setChecked}
    />
  );

  const legendPanel = checked ? (
    <MapOverlayPanel>{props.children}</MapOverlayPanel>
  ) : null;

  if (legendPlacement === 'below-toggle') {
    return (
      <Portal container={topLeftContainer}>
        <div className={styles.stack}>
          {toggle}
          {legendPanel}
        </div>
      </Portal>
    );
  }

  return (
    <>
      <Portal container={topLeftContainer}>{toggle}</Portal>

      {legendPanel ? (
        <Portal
          container={
            document &&
            document
              .getElementById(mapId)
              ?.getElementsByClassName('mapboxgl-ctrl-bottom-left')[0]
          }
        >
          {legendPanel}
        </Portal>
      ) : null}
    </>
  );
}

export default LegendControl;
